import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../api/client";

export interface RosterHand {
  key: string;
  name: string;
  role_key: string | null;
  runs: number;
  auto_completed: number;
  escalated: number;
  blocked_pre: number;
  failed: number;
  last_run_at: string | null;
}

/** The agents registered in this build, with how their recent runs went. */
export function useWorkforceRoster(workspaceId: string | undefined) {
  return useQuery<{ hands: RosterHand[] }, Error>({
    queryKey: ["workforce", workspaceId],
    enabled: !!workspaceId,
    queryFn: () =>
      apiGet<{ hands: RosterHand[] }>(
        `/api/workspaces/${workspaceId}/workforce`,
      ),
  });
}
